<template>
  <div v-if="tableData.length" class="spu-list-container-content">
    <div class="store-info">
      <span>{{ detail && detail.role && detail.role.name ? detail.role.name : '' }}</span>
    </div>

    <div class="spu-list">
      <div v-if="showRefundDescription" class="spu-refund-desc">
        訂單已扣除欠品與退貨品項重新計算最優惠活動
      </div>

      <div v-for="(group, index) in tableData" :key="group.key" class="container-spu-item">
        <div class="top-promotion">
          <div class="left-promotion flex-center">
            <div v-if="group.promotion && group.promotion.title" class="promotion-tag flex-center origin">特價</div>
            <div v-else class="promotion-tag flex-center blue">普通商品</div>
            <span v-if="group.promotion && group.promotion.title">{{ group.promotion.title }}</span>
          </div>
        </div>

        <order-detail-spu-list-item
          v-for="(item, itemIndex) in group.orderItemList"
          :key="item.id || itemIndex"
          :item-data="item"
          :detail="detail"
        />

        <div v-if="group.promotionPrice" class="promotion-price">
          <span class="label">小計：</span>
          <span>NT$ {{ group.promotionPrice }}</span>
        </div>
        <div
          v-if="group.promotion && group.promotion.title && tableData.length >= 2 && index < tableData.length - 1"
          class="diviser-line"
        />
      </div>
    </div>
  </div>
</template>

<script>
import orderDetailSpuListItem from "./order-detail-spu-list-item";

const createGroups = (promotionOrderItem) => {
  if (!promotionOrderItem) return [];

  const promotionGroups = (promotionOrderItem.promotionItemList || []).map((group, index) => ({
    key: `promotion-${index}`,
    promotion: group.promotion || null,
    promotionPrice: group.promotionPrice,
    orderItemList: (group.orderItemList || []).filter((item) => Number(item.type) === 0),
  }));
  const otherGroups = (promotionOrderItem.otherItemList || []).map((item, index) => ({
    key: `other-${index}`,
    promotion: null,
    promotionPrice: "",
    orderItemList: Number(item.type) === 0 ? [item] : [],
  }));

  return promotionGroups.concat(otherGroups).filter((group) => group.orderItemList.length);
};

export default {
  name: "order-detail-spu-list-widget",
  components: { orderDetailSpuListItem },
  props: {
    detail: { type: Object, default: () => ({}) },
    itemListKey: { type: String, default: "" },
  },
  computed: {
    selectedPromotionOrderItem() {
      const key = this.itemListKey === "refundSpu" ? "refundPromotionOrderItem" : "promotionOrderItem";
      return this.detail && this.detail[key];
    },
    tableData() {
      const groups = createGroups(this.selectedPromotionOrderItem);
      if (groups.length) return groups;

      return ((this.detail && this.detail.orderItemList) || [])
        .filter((item) => Number(item.type) === 0)
        .map((item, index) => ({
          key: `order-item-${index}`,
          promotion: null,
          promotionPrice: "",
          orderItemList: [item],
        }));
    },
    showRefundDescription() {
      return this.itemListKey === "refundSpu" && Number(this.detail && this.detail.userRefund) > 0;
    },
  },
};
</script>

<style lang="less" scoped>
.spu-list-container-content {
  padding: 0;

  .store-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    color: #323232;
    font-weight: bold;
  }
}

.spu-refund-desc {
  margin-bottom: 20px;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: #ffd3b2;
  color: #909090;
  font-size: 12px;
}

.container-spu-item { margin-bottom: 15px; }

.top-promotion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px 12px 0;

  .left-promotion {
    display: flex;
    color: #6f6f6f;
    font-size: 12px;
  }

  .promotion-tag {
    display: inline-block;
    min-width: 70px;
    margin-right: 5px;
    padding: 2px 8px;
    border: 1px solid #323233;
    border-radius: 4px;
    color: #323233;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;

    &.blue { border-color: #c9c9c9; background-color: #f5f5f5; color: #4b4b4b; }
    &.origin { border-color: #ffd3b2; color: #ef6500; }
  }
}

.flex-center { display: flex; align-items: center; justify-content: center; }

.promotion-price {
  padding: 10px 0;
  text-align: right;

  span { color: #909090; font-size: 18px; font-weight: bold; }
}

.diviser-line { width: 100%; height: 2px; margin-top: 10px; background-color: #e3e3e3; }
</style>
